<template>
  <div v-if="isEmpty(routeProducts)">
    <v-alert color="danger" border="left" dark>
      <v-icon>mdi-alert</v-icon>
      {{ $t('no_products_configured_for_route') }}
    </v-alert>
  </div>
  <v-data-table
    v-else
    class="vf-table"
    :items="recordedTemps"
    :loading="loading"
    :headers="tableFields">
    <template #item.timestamp="row">
      <if-set :value="row.value">
        <multi-time-display :time="row.value" />
      </if-set>
    </template>
    <template #item.product_name="row">
      <if-set :value="get(row.item, 'route_product.product.name')">
        <template #default="scope">
          {{ scope.value }}
        </template>
      </if-set>
    </template>
    <template #item.temperature="row">
      {{ temperatureToCustomerScale(row.value, row.item.temperature_scale) }} &deg; {{ customerContext.tempFormat() }}
    </template>
    <template #item.source="row">
      <if-set :value="row.value">
        {{ $tc(row.value) }}
      </if-set>
    </template>
  </v-data-table>
</template>

<script>
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay.vue'
import IfSet from '@/components/shared/IfSet'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import TemperatureMixin from '@/components/mixins/TemperatureMixin'
import { map, get, isEmpty } from 'lodash'

export default {
  name: 'RecordedTempTable',
  components: {
    MultiTimeDisplay,
    IfSet
  },
  mixins: [
    TemperatureMixin,
    CurrentUserMixin
  ],
  props: {
    routeProducts: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: true,
      recordedTemps: [],
      tableFields: [
        {
          value: 'timestamp',
          text: this.$tc('recording_time')
        },
        {
          value: 'product_name',
          text: this.$tc('product')
        },
        {
          value: 'temperature',
          text: this.$tc('temperature')
        },
        {
          value: 'source',
          text: this.$tc('source')
        }
      ]
    }
  },
  methods: {
    get: get,
    isEmpty: isEmpty,
    /**
     * Fetch the route product recorded temperatures, filtered by the route products on the route.
     * @returns {Promise<void>}
     */
    async fetchRecordedTemps () {
      this.loading = true
      const fields = [
        'timestamp',
        'temperature',
        'source',
        'route_product.product.name'
      ]
      const expand = [
        'route_product.product'
      ]
      try {
        const resp = await this.$orm('RouteProductRecordedTemperature').findAll({
          route_product_id: map(this.routeProducts, x => x.id).join(','),
          fields: fields.join(','),
          expand: expand.join(',')
        })
        this.recordedTemps = resp.getItems()
        this.loading = false
      } catch (error) {
        this.handleError(error)
      }
    }
  },
  mounted () {
    this.fetchRecordedTemps()
  }
}
</script>
